<template>
  <div class="div7 cutbox">

      <div class="text1">
        <span data-id="主标题1" data-range="5,9">{{ info.titles[0] }}</span>
        <span data-id="主标题2" data-range="5,9">{{ info.titles[2] }}</span>
      </div>
      <div class="text2" data-id="长特点1" data-range="8,16">{{ info.specialty[0] }}</div>


    <div class="text3"><img :src="info.image" alt=""></div>

      <div class="text4">
        <span data-id="长特点2" data-range="10,22">{{ info.specialty[1] }}</span>
        <span data-id="长特点3" data-range="10,22">{{ info.specialty[2] }}</span>
      </div>
      <div class="text5" data-id="公司" data-range="8,20">{{ info.company }}</div>


  </div>
</template>
<script>
export default {
  name: 'TUWEN007',
  props: {
    info: Object
  },
}
</script>
